import { apiClient } from "@/api/api-client";
import createBaseService, { type Pagination } from "@/api/base-service.ts";
import type { CaseMember } from "@/features/case-record/types/case-member";

const caseMemberService = {
	...createBaseService<CaseMember>("/backoffice/case-members"),
	listParty: async (params = {}) => {
		const response = await apiClient.get<{ data: CaseMember[]; meta: Pagination }>("/backoffice/case-members/party-complaints", { params });

		return response.data;
	},
	listMultipleParties: async (params = {}) => {
		const response = await apiClient.get<{ data: CaseMember[]; meta: Pagination }>("/backoffice/case-members/evidence-party-complaints", { params });

		return response.data;
	},
};

export default caseMemberService;
